(function() {

  const check = document.querySelector('body.search');

  if( check ) {
    const search_controler = new ArchiveControler();
      search_controler.register_archive_container( document.getElementById('SearchContent') );
      search_controler.register_filter_select( document.getElementById('Filter_1') );
      search_controler.register_search_input( document.getElementById('Search') );
      search_controler.register_self_loading_classname('search__loading');
      search_controler.register_more_button_classname('button__more');
      search_controler.on('new-content', function(htmlDoc, newContent) {
        try {
          document.getElementById('SearchQuery').innerHTML = htmlDoc.getElementById('SearchQuery').innerHTML;
        } catch(e) {
        }
      });
  }

})();